import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M43.9716 15.9247C37.6116 1.31704 25.5727 1.82451 24.7914 1.88422C24.0102 1.94392 11.6508 2.08325 5.62133 15.9247C1.49485 25.3878 0.984034 42.0951 2.72677 54.9514C3.508 60.693 7.95498 87.8684 24.7614 87.8684C41.5678 87.8684 46.0548 60.6731 46.796 54.9116C48.5988 42.0652 48.088 25.3878 43.9716 15.9247Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
  )
}
